import {
  formSpecification as commonFormSpecification,
  type S136FormRejectedFormData as CommonS136FormRejectedFormData,
} from "../common/s136FormRejected.js";

export const formSpecification = commonFormSpecification;

export type S136FormRejectedFormData = CommonS136FormRejectedFormData;
